import React, { useEffect } from "react";
import { Paper, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getFormattedNumber, prettyNumericRound } from "../../../utils";
import CustomLabel from "../../../components/CustomLabel";
import { useLazyGetTotalQuery } from "../../../services/totalApi";

const PaperSx = { px: 1, py: 0.5, display: "flex", alignItems: "center" };

const CenterAlignSx = { display: "flex", alignItems: "center" };

const Total = () => {
  const store = useSelector((store) => store.global.store);
  const total = useSelector((store) => store.total);
  const [getTotal] = useLazyGetTotalQuery();

  useEffect(() => {
    getTotal({ storeId: store?.id, type: "initialLoad" });
  }, [getTotal, store?.id]);

  return (
    <Paper sx={PaperSx}>
      <Grid container spacing={0} columns={15} sx={CenterAlignSx}>
        <Grid item xs={0.8}>
          <Typography variant="caption" fontWeight={500} color="primary">
            TOTAL
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <CustomLabel
            label="Selected"
            value={`${total?.selected}/${total?.totalPogs}`}
          />
        </Grid>
        <Grid item xs={2}>
          <CustomLabel label="Existing" value={total?.existing} />
        </Grid>
        <Grid item xs={1.6}>
          <CustomLabel label="LF" value={`${total?.lf}ft`} />
        </Grid>
        <Grid item xs={1.6}>
          <CustomLabel label="Adj. LF" value={`${total?.adjLf}ft`} />
        </Grid>
        <Grid item xs={2}>
          <CustomLabel label="SKU Qty" value={total?.skuQty} />
        </Grid>
        <Grid item xs={2.5}>
          <CustomLabel
            label="Adj. Cost"
            value={`$${getFormattedNumber(
              prettyNumericRound(total?.adjCost || 0)
            )}`}
          />
        </Grid>
        <Grid item xs={2.5}>
          <CustomLabel
            label="Ext. Cost"
            value={`$${getFormattedNumber(
              prettyNumericRound(total?.extCost || 0)
            )}`}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Total;
